import React from "react";

const SupportTicketSuccess = () => {
    return (
        <div className="success-container" style={{height: "80vh"}}>
            <h2 className="title mt-0 text-center"><i className="fa-solid fa-paper-plane-top"></i> Ticket envoyé !</h2>
            <div>
                <p>Votre demande a été envoyée. Nous vous répondrons dans les plus brefs délais.</p>
            </div>
            <div>
                <p>Votre équipe Solution Digitale.</p>
            </div>
            <div>
            </div>
        </div>);
};

export default SupportTicketSuccess;
